import Enum from './Enum';

export default class DataProviderStatus extends Enum {
  static ACTIVE = new DataProviderStatus('ACTIVE', 'data_providers.status_values.active');
  static INACTIVE = new DataProviderStatus('INACTIVE', 'data_providers.status_values.inactive');
}